export default class BopCategory {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.name = jsonResponse["name"];
            this.reportingCode = jsonResponse["reporting-code"];
            this.inboundDescription = jsonResponse["inbound-description"];
            this.outboundDescription = jsonResponse["outbound-description"];
            this.threshold = jsonResponse["threshold"];
        }
    }
}
